module.exports = __webpack_public_path__ + "assets/whatsapp.54c17859.svg";